import ResetPasswordForm from '@/modules/auth/reset-password-form'

const ResetPasswordPage = () => {
  return (
    <div className='flex h-full w-full flex-col bg-white'>
      <main className='flex flex-1 items-center justify-center p-4'>
        <div className='mx-auto w-full max-w-md'>
          <div className='mb-8 text-center'>
            <h1 className='mb-2 text-2xl font-bold text-gray-700'>
              Reset Password
            </h1>
            <p className='text-gray-600'>
              Enter your email and new password below to reset your password.
            </p>
          </div>
          <ResetPasswordForm />
        </div>
      </main>
    </div>
  )
}

export default ResetPasswordPage